const $ = window.jQuery;
const $window = window.$window || $(window);

const MainMenu = {

  init() {

    // TODO: remove if unused
    var mainNavLi = $('.current_page_item').parent().closest('li');
    $(mainNavLi).addClass("active-main-nav")

    // TODO: something around single main nav active if needed not sure NOt defined yet
    var url = window.location.pathname;
    var newUrl = url.replace('/', '');
    // console.log('url', newUrl)
    var currentSingleMainNav = $('.single-main-nav a[href*="' + newUrl + '"]');
    // console.log('currentSingleMainNav', currentSingleMainNav)
    currentSingleMainNav.closest('li').addClass('active');
  }

};

export default MainMenu;